<template>
  <el-tabs
    v-bind="$attrs" :class="[style.segmented, `segmented-${size}`, 'block']" :tab-bar-gutter="20"
    @tab-change="handleTabChange"
  >
    <template v-if="slots.default" #default>
      <slot />
    </template>
    <template v-else #default>
      <el-tab-pane v-for="item in options" :key="item.value" :name="item.value" :label="item.label" />
    </template>
  </el-tabs>
</template>

<script setup lang="ts">
const slots = useSlots();
defineProps({
  size: {
    validator(value: string) {
      return ['max', 'large', 'default', 'small', 'mini'].indexOf(value) > -1;
    },
    type: String,
    default: 'default'
  },
  options: {
    type: Array,
    default: () => []
  }
}
);
const emit = defineEmits(['change']);
const handleTabChange = val => {
  emit('change', val);
};
</script>
<style lang="scss" module="style">
:global {
  .segmented {
    &-max {
      --el-button-size: var(--height-max);
      --el-font-size-base: var(--font-size-max);
      --el-border-radius-base: var(--radius-max);
      --el-button-font-weight: var(--font-weight-max);
      --el-tabs-header-height: calc(var(--height-max) - 4px)
    }

    &-large {
      --el-button-size: var(--height-large);
      --el-font-size-base: var(--font-size-large);
      --el-border-radius-base: var(--radius-large);
      --el-button-font-weight: var(--font-weight-large);
      --el-tabs-header-height: calc(var(--height-large) - 4px)
    }

    &-default {
      --el-button-size: var(--height-default);
      --el-font-size-base: var(--font-size-default);
      --el-border-radius-base: var(--radius-default);
      --el-button-font-weight: var(--font-weight-default);
      --el-tabs-header-height: calc(var(--height-default) - 4px)
    }

    &-small {
      --el-button-size: var(--height-small);
      --el-font-size-base: var(--font-size-small);
      --el-border-radius-base: var(--radius-small);
      --el-button-font-weight: var(--font-weight-small);
      --el-tabs-header-height: calc(var(--height-small) - 4px)
    }

    &-mini {
      --el-button-size: var(--height-mini);
      --el-font-size-base: var(--font-size-mini);
      --el-border-radius-base: var(--radius-mini);
      --el-button-font-weight: var(--font-weight-mini);
      --el-tabs-header-height: calc(var(--height-mini) - 4px);
    }
  }
}

.segmented {

  --el-color-primary: var(--gray-gray10);

  :global {
    .el-tabs__header {
      margin-bottom: 0;
      background: var(--fill-fill4);
      padding: 2px;
      border-radius: var(--el-border-radius-base);
      height: var(--el-button-size);
    }
    .el-tabs__nav {
      float: inherit;
      display: flex;
      gap: 2px;
    }

    .el-tabs__nav-wrap::after {
      display: none;
    }

    .el-tabs__item {
      font-size: var(--el-font-size-base);
      font-weight: var(--el-button-font-weight);
      color: var(--text-text3);
      padding: 0;
      position: relative;
      z-index: 2;
      display: inline-flex;
      align-items: center;

      &::after,&::before{
        content: ' ';
        display: inline-block;
        height: 100%;
        width: calc(var(--el-border-radius-base) * 2);
      }

      &:hover {
        background: var(--fill-fill3);
        border-radius: var(--el-border-radius-base);
      }

      &:last-child {
        margin-right: 0;
      }
    }

    .el-tabs__item.is-active {
      color: var(--text-text1);
    }

    .el-tabs__active-bar {
      top: 0;
      height: var(--el-tabs-header-height);
      background: var(--fill-fill3);
      border-radius: var(--el-border-radius-base);
    }
  }

}
</style>
